import React, { useMemo } from 'react';
import { Typography, Tooltip } from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
} from '@mui/icons-material';

const MetadataToggle = ({ disabled = false, showMeta, gridWidth, onShowMetaChanged }) => {
  const style = useMemo(() => {
    return {
      width: gridWidth,
    };
  }, [gridWidth]);

  if (disabled) return null;

  return (
    <div style={style} onClick={onShowMetaChanged} className="recipe-builder-meta-collapsible">
      <Tooltip title="Toggle visibility of metadata fields" arrow placement="right">
        {showMeta ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
      </Tooltip>
      <Typography variant="bodySmall" className="recipe-builder-meta-text">
        Metadata
      </Typography>
    </div>
  );
};

export default MetadataToggle;
